import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi, ColumnApi, ColDef, GridReadyEvent } from 'ag-grid-community';
import * as moment from 'moment';
import { AlertService } from 'src/app/_services/alert.service';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ProductService } from '../../product-management/product-service';
import { ProductSubCategoryService } from '../../product-subcategory-management/product-subcategory-service';
import { ServiceProviderService } from '../../service-provider-management/service-provider-service';
import { CommissionProfileService } from '../commission-profile-service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';


export interface CustomerListFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?: string,
  "Status"?: string,
  "KycStatus"?: string

}

export class SlabTableFormat {
  "id": number;
  "fromAmount": number;
  "toAmount": number;
  "commissionType": String;
  "agentCommission": number;
  "subAgentCommission": number;
  "minCommission": number;
  "maxCommission": number;
  "effectiveUpdatedDate": String;
  "productId" : number;
  "updatedBy": String;
  "updatedOn": String;
  "approvedBy": String;
  "aprrovedOn": String;
  "isAmountDisabled": Boolean;
  "showEditButton": Boolean;
  "isDatepickerDisabled": Boolean;
  "isSelectDisabled": Boolean;
}

const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;
@Component({
  selector: 'app-commission-profile-edit',
  templateUrl: './commission-profile-edit.component.html',
  styleUrls: ['./commission-profile-edit.component.scss']
})
export class CommissionProfileEditComponent implements OnInit, OnDestroy {

  @ViewChild('openReviewSlab') private slabModal: ModalComponent;
  modalSlabReview: ModalConfig;
  
  public permissions : any;
  editCommissionProfileForm: FormGroup;
  submitted: boolean = false;
  submittedCommission: boolean = false;
  activeTab: any = "service";
  globalSearch: string = '';
  public rowData!: any[];
  private filterObj: any = {};
  private gridApi!: GridApi;
  collectiondata: number = 0;
  collectionSize: number = 0;
  private gridColumnApi!: ColumnApi;
  currentPage: number = 1;
  public pageNumber: number
  ellipses: boolean = true;
  maxSize: number;

  private columnApi: ColumnApi;
  private gridApiDirect: GridApi;
  private gridApiSlab: GridApi;
  slabTypeData: SlabTableFormat;
  public slabData: any[];
  public savedSlabData : any[];
  public finalCommissionData : any[];
  showDataTable : boolean = false;
  countryDropDown : any[];
  categoryDropDown : any[];
  subCategoryDropDown : any[];
  productDropDown : any[];
  selectedProduct : any;
  serviceProviderDropDown : any[];
  productName : any;
  countryName : any;
  serviceProviderName : any;
  commissionId : any;
  savedSlabDataTable : boolean = false;
  showReviewModal : boolean = false;
  slabRemarks : any;
  oldSlab : any[];
  newSlab : any[];
  showOldSlab : boolean = false;
  showNewSlab : boolean = false;
  showCopyButton : boolean = false;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefsSaved: ColDef[] = [
    {field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable:false},
    {field: 'toAmount',lockVisible:true,  headerName: 'To Amount', editable:false},
    {field: 'commissionType',lockVisible:true,  headerName: 'Commission Type', editable:false},
    {field: 'agentCommission',lockVisible:true,  headerName: 'Agent Commission',editable:false},
    {field: 'id', headerName: 'ID', hide: true },
    {field: 'subAgentCommission',lockVisible:true,  headerName: 'Sub-Agent Commission',editable:false},
    {field: 'effectiveUpdatedDate',lockVisible:true,  headerName: 'Effective Update Date', editable:false},
    {field: 'createdBy',lockVisible:true,  headerName: 'Created By', editable:false},
    {field: 'createdOn',lockVisible:true,  headerName: 'Created On' ,editable:false},
    {field: 'approvedBy',lockVisible:true,  headerName: 'Approved By', editable:false},
    {field: 'approvedOn',lockVisible:true,  headerName: 'Approved On', editable:false},
    {field: 'status',lockVisible:true,  headerName: 'Status', editable:false},
 
  ];

  public columnDefs: ColDef[] = [
    
    {field: 'fromAmount', headerName: 'From Amount',cellRenderer: AmountInputCellRenderer, editable:false},
    {
      field: 'toAmount', headerName: 'To Amount', resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        const toAmountValue = parseFloat(params.newValue);
        const maxBalanceValue = parseFloat(this.editCommissionProfileForm.value.maxBalance);
        if (!isNaN(toAmountValue) && toAmountValue < maxBalanceValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.finalCommissionData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate', headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.finalCommissionData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        console.log("MAP"); 
        console.log(this.finalCommissionData);
        this.gridApiSlab.setRowData(this.finalCommissionData);
      }
    },
    {
      field: 'commissionType', lockVisible: true, headerName: 'Commission Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        if (rowNode) {
          this.finalCommissionData[params.node.rowIndex].commissionType = params.newValue;
          this.finalCommissionData[params.node.rowIndex].agentCommission = 0;
          this.finalCommissionData[params.node.rowIndex].subAgentCommission = 0;
          this.gridApiSlab.setRowData(this.finalCommissionData);
        }
      }
    },
    { field: 'agentCommission', headerName: 'Agent Commission', cellRenderer: InputCellRenderer , onCellValueChanged: (params: any) => {
      if (params.data.commissionType == "PERCENTAGE") {
        if(Number(params.newValue) > 100){
          this.alertService.toastWarringMessageAlertWithMessage("Agent Commission cannot be greater than 100 Percentage");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].agentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      }else if(params.data.commissionType == "FLAT"){
        console.log(params.data.toAmount);
        if(Number(params.newValue) > Number(params.data.toAmount)){
          this.alertService.toastWarringMessageAlertWithMessage("Agent Commission cannot be greater than 'TO AMOUNT'");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].agentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      } 
    }},
    { field: 'subAgentCommission', headerName: 'SubAgent Commission', cellRenderer: InputCellRenderer , onCellValueChanged: (params: any) => {
      if (params.data.commissionType == "PERCENTAGE") {
        if(Number(params.newValue) > 100){
          this.alertService.toastWarringMessageAlertWithMessage("SubAgent Commission cannot be greater than 100 Percentage");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].subAgentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      }else if(params.data.commissionType == "FLAT"){
        console.log(params.data.toAmount);
        if(Number(params.newValue) > Number(params.data.toAmount)){
          this.alertService.toastWarringMessageAlertWithMessage("SubAgent Commission cannot be greater than 'TO AMOUNT'");
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
          if(rowNode){
            this.finalCommissionData[params.node.rowIndex].subAgentCommission = 0;
            this.gridApiSlab.setRowData(this.finalCommissionData);
          }
        }
      } 
    }},

  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  savedDatatableColumn: ColDef[] = [...(this.columnDefsSaved.filter((col) => !col?.hide))];


  constructor(private router: Router,private formBuilder : FormBuilder,private alertService : AlertService, private productService : ProductService, private subCategoryService : ProductSubCategoryService,private sanitizer: DomSanitizer,private providerService : ServiceProviderService,private commissionService : CommissionProfileService,private route : ActivatedRoute,private menuService : MenusService) { }

  ngOnDestroy(){
    console.log("Component Destoryed");
    if(this.slabModal.isOpen()){
      this.slabModal.close();
    } 
  }

  async ngOnInit() {

    const path = "/commissionProfile";
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if (this.permissions == null || this.permissions == '' || !this.permissions ) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.activeTab ="service";
    this.slabData = [];
    this.savedSlabData = [];
    
    this.editCommissionProfileForm = this.formBuilder.group({
      commissionProfileName : ['',Validators.required],
      commissionProfileDesc : ['',Validators.required],
      country : [null,Validators.required],
      product : [null,Validators.required],
      serviceProvider : [null,Validators.required],
      maxBalance : ['',Validators.required],
      status : ['',Validators.required],
    })

    this.commissionId = this.route.snapshot.queryParamMap.get("mid");
    console.log("Commission ID : "+this.commissionId);
    this.commissionService.getCommissionProfile(this.commissionId).subscribe((response:any)=>{
      console.log(response);
      this.editCommissionProfileForm.controls.commissionProfileName.setValue(response.response.data.name)
      this.editCommissionProfileForm.controls.commissionProfileDesc.setValue(response.response.data.description)
      this.editCommissionProfileForm.controls.country.setValue(response.response.data.countryName)
      this.countryName = response.response.data.countryName;
      this.editCommissionProfileForm.controls.product.setValue(response.response.data.productName)
      this.productName = response.response.data.productName;
      this.editCommissionProfileForm.controls.serviceProvider.setValue(response.response.data.serviceProviderName)
      this.serviceProviderName = response.response.data.serviceProviderName;
      this.editCommissionProfileForm.controls.maxBalance.setValue(response.response.data.serviceProviderMaxBalance)
      this.editCommissionProfileForm.controls.status.setValue(response.response.data.status)
      
    })

    this.commissionService.getCommissionProfileSlab(this.commissionId).subscribe((response:any)=>{
      console.log(response);
      this.savedSlabData = response.response.data.slabs;
      console.log(this.savedSlabData)
      if(this.savedSlabData.length != 0){
        this.savedSlabDataTable = true;
        for(let i:number= 0; i<this.savedSlabData.length; i++){
          if(this.savedSlabData[i].status == "ACTIVE"){
            this.showCopyButton = true;
            break;
          }
        }
      }
    });

    this.modalSlabReview = {
      modalTitle: "Commission Profile Slab",
      modalSize: 'xl',
  
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    
  }

  get addServiceProviderFormControl() {
    return this.editCommissionProfileForm.controls;
  }

  cancelButton(){
    this.router.navigateByUrl('/commissionProfile')
  }

  editCommissionProfile(data:any){
    this.submitted = true;
    console.log(data);
    if(this.editCommissionProfileForm.valid){
      console.log("Valid");
      let updateRequestForm = {
        "id": this.commissionId,
        "description": this.editCommissionProfileForm.value.commissionProfileDesc
      }
      console.log(updateRequestForm);
      this.commissionService.updateCommissionProfile(updateRequestForm).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        this.activeTab = "commission";
      }else{
        this.alertService.toastWarringMessageAlertWithMessage("Error while updating the commission profile");
        return;
      }
    })
    }else{
      console.log("Not Valid");
    }
  }

  updateCommissionSlab(){
    if(this.editCommissionProfileForm.valid){
      console.log("Valid");
        this.finalCommissionData = JSON.parse(JSON.stringify(this.finalCommissionData));
        this.finalCommissionData.map((_:any)=>{
        delete _.isAmountDisabled;
      })

      let addSlabRequestForm = {
        "id":this.commissionId,
        "slabs" : this.finalCommissionData,
      };
      console.log("Request Data : ",addSlabRequestForm)
    this.commissionService.updateCommissionProfileSlab(addSlabRequestForm).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        Swal.fire('Commission Profile slabs save successfully', '', 'success').then((result)=>{
          if (result.isConfirmed) {
            this.router.navigate(['/commissionProfile']);
          } 
        });
      }else if(response.response.status == 400){
        Swal.fire(response.response.message, '', 'error');
        return;
      }else{
        Swal.fire('Error while saving saving commission profile slab', '', 'error');
      }

    })
    }else{
      console.log("Not Valid");
    }
  }


  switchTab(tab: string): void {
    this.activeTab = tab;
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApiSlab = params.api
  }


  copySlab(){
    if(this.savedSlabData.length != 0){
      for(let i : number = 0; i<this.savedSlabData.length; i++){
        if(this.savedSlabData[i].status == "PENDING"){
          this.alertService.errorAlertWithMessage("You cannot copy slabs because previous slabs are in Pending state");
          return;
        }
      }
    }
    let data = JSON.parse(JSON.stringify(this.savedSlabData));
    data.map((_:any)=>{
        delete _.id;
        delete _.countryId;
        delete _.dateTo;
        delete _.commissionProfileId;
        delete _.approvedOn;
        delete _.approvedBy;
        delete _.minCommission;
        delete _.maxCommission;
        delete _.dateTo;
        delete _.status;
        delete _.createdBy;
        delete _.createdOn;
        delete _.productId;
        delete _.serviceProviderId;
        delete _.effectiveUpdatedDate;
        _.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
      })
    this.showDataTable = true;
    this.finalCommissionData = [];
    this.finalCommissionData = data;
  }

  addNewSet(){
    if(this.savedSlabData.length != 0){
      for(let i : number = 0; i<this.savedSlabData.length; i++){
        if(this.savedSlabData[i].status == "PENDING"){
          this.alertService.errorAlertWithMessage("You cannot add new slabs because previous slabs are in Pending state");
          return;
        }
      }
    }
    this.selectedProduct = "";
    this.slabData = [];
    this.finalCommissionData = [];
    this.selectedProduct = "";
    console.log(this.selectedProduct);
    this.showDataTable = false;
    if(this.editCommissionProfileForm.valid){
      this.showDataTable = true;
      this.slabTypeData = new SlabTableFormat;
      this.slabTypeData.fromAmount = 1;
      this.slabTypeData.isAmountDisabled = true;
      this.slabTypeData.toAmount = Number(this.editCommissionProfileForm.value.maxBalance);
      this.slabTypeData.productId = this.selectedProduct.id;
      this.slabTypeData.commissionType = "PERCENTAGE";
      this.slabTypeData.agentCommission = 0;
      this.slabTypeData.subAgentCommission = 0;
      this.slabTypeData.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");;
      this.finalCommissionData.push(this.slabTypeData);
    }
    
  }

  addRow(){
    const newRow = { fromAmount: 1, toAmount: 0, commissionType: "PERCENTAGE", agentCommission: 0,subAgentCommission: 0, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false };
    this.finalCommissionData = [newRow, ...this.finalCommissionData];
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }

  clearButton(){
    this.slabData = [];
    this.finalCommissionData = [];
    let slabDataObj = { fromAmount: 1, isAmountDisabled: true, toAmount: Number(this.editCommissionProfileForm.value.maxBalance), commission: 0, commissionType: "PERCENTAGE", agentCommission: 0,subAgentCommission: 0, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm")};
    this.finalCommissionData.push(slabDataObj);
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log(charCode);
    if(charCode == 32){
      return true;
    }else if ((charCode == 96 || charCode < 65 ||charCode > 122) && (charCode < 48 ||charCode > 57)) {
      return false;
    }
    return true;
  }

  onPaste(e: any) {
    e.preventDefault()
  }

  reviewSlab(event:any){
    event.target.blur()
    this.oldSlab = [];
    this.newSlab = [];
    this.showOldSlab = false;
    this.showNewSlab = false;
    if(this.savedSlabData.length == 0){
      this.alertService.errorAlertWithMessage("No slabs for review");
      return;
    }
   
    for(let i:number = 0;i<this.savedSlabData.length;i++){
      if(this.savedSlabData[i].status == "PENDING"){
        this.newSlab.push(this.savedSlabData[i]);
      }else{
        this.oldSlab.push(this.savedSlabData[i]);
      }
    }
    if(this.newSlab.length == 0){
      this.alertService.errorAlertWithMessage("No slabs for review");
      return;
    }else{
      if(this.oldSlab.length == 0){
        this.showOldSlab = false;
      }else{
        this.showOldSlab = true;
      }
      this.showNewSlab = true;
      this.slabModal.open();
    }
  }

  slabStatusChange(status:any){
    console.log(status);
    console.log(this.slabRemarks);
    if(this.slabRemarks == undefined){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter remark");
      return;
    }

    let remarkBody = {
      "id": this.commissionId,
      "remark" : this.slabRemarks,
    }
    console.log(remarkBody);
    this.commissionService.commissionProfileSlabStatus(status,remarkBody).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        this.slabModal.close();
        this.commissionService.getCommissionProfileSlab(this.commissionId).subscribe((response:any)=>{
          console.log(response);
          this.savedSlabData = response.response.data.slabs;
          console.log(this.savedSlabData)
          if(this.savedSlabData.length != 0){
            this.savedSlabDataTable = true;
          }
        });
        Swal.fire('Slab status change successfully','','success');
      }else{
        Swal.fire('Error while changing the slab status','','error');
      }
    })
  }

}
